document.addEventListener('alpine:init', () => {
  const ENABLE_SUBSCRIPTION_CHECKOUT_GIFT = false;
  const SUBSCRIPTION_CHECKOUT_GIFT_VARIANT_ID = 48410646610163;
  const SUBSCRIPTION_CHECKOUT_GIFT_DISCOUNT_CODE = 'FREEBOTTLE';

        Alpine.store('cart', {
          data: null, // This will hold the cart object from Shopify
          loading: false,
          checkoutSnapshotApplied: false,
          giftSyncInProgress: false,

          // Method to fetch the latest cart data from Shopify
          async getCartData(options = {}) {
            const { skipGiftSync = false } = options;
            this.loading = true;
            try {
              const response = await fetch(window.Shopify.routes.root + 'cart.js');
              this.data = await response.json();

              if (!this.checkoutSnapshotApplied) {
                await this.reconcileCheckoutSnapshot();
              }

              if (ENABLE_SUBSCRIPTION_CHECKOUT_GIFT && !skipGiftSync) {
                const giftSynced = await this.ensureSubscriptionCheckoutGift(this.data);

                if (giftSynced) {
                  const refreshedResponse = await fetch(window.Shopify.routes.root + 'cart.js');
                  if (refreshedResponse.ok) {
                    this.data = await refreshedResponse.json();
                  }
                }
              }
            } catch (error) {
              console.error('Error fetching cart data:', error);
            } finally {
              this.loading = false;
            }
          },

          // Save a snapshot of the current cart before checkout
          saveCheckoutSnapshot() {
            if (!this.data || !this.data.items) return;

            const snapshot = {
              createdAt: Date.now(),
              token: this.data.token || null,
              items: this.data.items.map((item) => ({
                variant_id: item.variant_id,
                selling_plan_id: item.selling_plan_id || (item.properties && item.properties['_selling_plan_id'] ? parseInt(item.properties['_selling_plan_id']) : null),
                quantity: item.quantity,
              })),
            };
            
            localStorage.setItem('checkout_cart_snapshot', JSON.stringify(snapshot));
            this.checkoutSnapshotApplied = false;
          },

          // Reconcile cart against snapshot (remove checkout add-ons)
          async reconcileCheckoutSnapshot() {
            this.checkoutSnapshotApplied = true;

            const raw = localStorage.getItem('checkout_cart_snapshot');
            if (!raw || !this.data || !this.data.items) return;

            let snapshot;
            try {
              snapshot = JSON.parse(raw);
            } catch (e) {
              localStorage.removeItem('checkout_cart_snapshot');
              return;
            }

            const maxAgeMs = 30 * 60 * 1000;
            if (!snapshot.createdAt || Date.now() - snapshot.createdAt > maxAgeMs) {
              localStorage.removeItem('checkout_cart_snapshot');
              return;
            }

            // If token changed, do not apply
            if (snapshot.token && this.data.token && snapshot.token !== this.data.token) {
              localStorage.removeItem('checkout_cart_snapshot');
              return;
            }

            const findSnapshotItem = (cartItem) => {
              const cartVariantId = cartItem.variant_id;
              let cartSellingPlanId = cartItem.selling_plan_id;
              if (!cartSellingPlanId && cartItem.properties && cartItem.properties['_selling_plan_id']) {
                cartSellingPlanId = parseInt(cartItem.properties['_selling_plan_id']);
              }

              return snapshot.items.find((snap) => {
                const snapSellingPlanId = snap.selling_plan_id ? parseInt(snap.selling_plan_id) : null;
                const sellingPlanMatch = snapSellingPlanId ? cartSellingPlanId === snapSellingPlanId : !cartSellingPlanId;
                return snap.variant_id === cartVariantId && sellingPlanMatch;
              });
            };

            let needsUpdate = false;

            for (const cartItem of this.data.items) {
              const snapItem = findSnapshotItem(cartItem);

              if (!snapItem) {
                await this.updateItem(cartItem.key, 0);
                needsUpdate = true;
                continue;
              }

              if (cartItem.quantity !== snapItem.quantity) {
                await this.updateItem(cartItem.key, snapItem.quantity);
                needsUpdate = true;
              }
            }

            if (needsUpdate) {
              await this.getCartData({ skipGiftSync: true });
            }

            localStorage.removeItem('checkout_cart_snapshot');
          },

          // Helper method to get the total item count
          get itemCount() {
            return this.data ? this.data.item_count : 0;
          },

          // Helper method to get the total price (formatted as per Shopify's cart.js response)
          get totalPrice() {
            return this.data ? this.data.total_price : 0;
          },

          get activeDiscountPercent() {
            return this.getActiveDiscountPercent();
          },

          get activeDiscountPercentLabel() {
            const percent = this.activeDiscountPercent;
            if (percent <= 0) {
              return '';
            }

            return Number.isInteger(percent)
              ? String(percent)
              : String(parseFloat(percent.toFixed(2)));
          },

          getActiveDiscountPercent(cartData = null) {
            const cart = cartData && typeof cartData === 'object' ? cartData : this.data;
            if (!cart) {
              return 0;
            }

            const normalizePercent = (value) => {
              const parsed = parseFloat(value);
              if (!Number.isFinite(parsed) || parsed <= 0) {
                return 0;
              }

              return Math.round(parsed * 100) / 100;
            };

            const percentFromText = (value) => {
              if (!value) {
                return 0;
              }

              const match = String(value).match(/(\d+(?:\.\d+)?)\s*%/);
              return match ? normalizePercent(match[1]) : 0;
            };

            const percentFromApplication = (application) => {
              if (!application || typeof application !== 'object') {
                return 0;
              }

              const valueType = String(application.value_type || application.type || '').toLowerCase();
              if (valueType.indexOf('percent') !== -1) {
                return normalizePercent(application.value || application.percentage || application.rate);
              }

              return (
                percentFromText(application.title) ||
                percentFromText(application.description) ||
                percentFromText(application.code)
              );
            };

            const collectApplications = (source) => {
              if (!Array.isArray(source)) {
                return [];
              }

              return source.filter(Boolean);
            };

            const applications = [
              ...collectApplications(cart.cart_level_discount_applications),
              ...collectApplications(cart.discount_applications),
              ...collectApplications(cart.discounts),
              ...collectApplications(cart.discount_codes),
            ];

            if (Array.isArray(cart.items)) {
              cart.items.forEach((item) => {
                collectApplications(item && item.discounts).forEach((application) => {
                  applications.push(application);
                });

                if (Array.isArray(item && item.line_level_discount_allocations)) {
                  item.line_level_discount_allocations.forEach((allocation) => {
                    if (allocation && allocation.discount_application) {
                      applications.push(allocation.discount_application);
                    }
                  });
                }
              });
            }

            let highestPercent = 0;

            applications.forEach((application) => {
              const percent = percentFromApplication(application);
              if (percent > highestPercent) {
                highestPercent = percent;
              }
            });

            return highestPercent;
          },

          // Helper method to find a cart item by variant and selling plan
          findCartItem(variantId, sellingPlanId) {
            if (!this.data || !this.data.items) {
              return null;
            }

            const numVariantId = parseInt(variantId);
            const numSellingPlanId = sellingPlanId ? parseInt(sellingPlanId) : null;

            return this.data.items.find((item) => {
              const variantMatch = item.variant_id === numVariantId;

              // Check selling plan ID - first try selling_plan_id field, then check properties
              let cartSellingPlanId = item.selling_plan_id;
              if (!cartSellingPlanId && item.properties) {
                const propValue = item.properties['_selling_plan_id'];
                cartSellingPlanId = propValue ? parseInt(propValue) : null;
              }

              const sellingPlanMatch = numSellingPlanId ? cartSellingPlanId === numSellingPlanId : !cartSellingPlanId;

              if (variantMatch && sellingPlanMatch) {
                return true;
              }
              return false;
            });
          },

          // Helper method to check if an item is in the cart
          itemInCart(variantId, sellingPlanId) {
            return this.findCartItem(variantId, sellingPlanId) !== null;
          },

          hasSubscriptionItem(cartItems) {
            if (!Array.isArray(cartItems)) {
              return false;
            }

            return cartItems.some((item) => {
              if (item.selling_plan_id || item.selling_plan_allocation) {
                return true;
              }

              if (item.properties && item.properties['_selling_plan_id']) {
                return true;
              }

              return false;
            });
          },

          hasVariantInCart(cartItems, variantId) {
            if (!Array.isArray(cartItems)) {
              return false;
            }

            const normalizedVariantId = parseInt(variantId);
            return cartItems.some((item) => item.variant_id === normalizedVariantId);
          },

          isSubscriptionCheckoutGiftItem(item) {
            return !!(
              item &&
              item.variant_id === SUBSCRIPTION_CHECKOUT_GIFT_VARIANT_ID &&
              item.properties &&
              item.properties._subscription_checkout_gift
            );
          },

          getLineItemTitle(item) {
            if (!item) {
              return '';
            }

            if (this.isSubscriptionCheckoutGiftItem(item)) {
              const baseTitle = item.product_title || item.title || 'Free Gift';
              return `${baseTitle} (FREE)`;
            }

            return (item.properties && item.properties._title) || item.product_title || item.title || '';
          },

          getLineItemImageStyle(item) {
            if (!item) {
              return '';
            }

            const raw = (item.properties && item.properties._image) || item.image || '';
            if (!raw) {
              return '';
            }

            let url = String(raw).trim();

            if (/^(https?:)?\/\//i.test(url) || url.charAt(0) === '/') {
              // Absolute, protocol-relative, or already root-relative — use as-is.
            } else if (url.indexOf('files/') === 0 || url.indexOf('/files/') !== -1) {
              // Value already carries the Shopify "files/" segment (e.g. "files/foo.png").
              url = '/cdn/shop/' + url.replace(/^\/+/, '');
            } else {
              // Bare filename from the image_product metafield (e.g. "foo.png").
              url = '/cdn/shop/files/' + url;
            }

            // Quote + encode so filenames with spaces or commas don't break url().
            return `background-image: url("${encodeURI(url)}")`;
          },

          findCartItemByVariant(cartItems, variantId) {
            if (!Array.isArray(cartItems)) {
              return null;
            }

            const normalizedVariantId = parseInt(variantId);
            return cartItems.find((item) => item.variant_id === normalizedVariantId) || null;
          },

          hasActiveDiscountCode(cart, discountCode) {
            if (!cart) {
              return false;
            }

            const normalizedDiscountCode = String(discountCode || '').trim().toUpperCase();
            if (!normalizedDiscountCode) {
              return false;
            }

            const extractDiscountCandidates = (application) => {
              const candidates = [
                application && application.title,
                application && application.code,
                application && application.description,
              ]
                .filter(Boolean)
                .map((value) => String(value).trim().toUpperCase());

              return candidates;
            };

            const hasMatchingDiscount = (applications) => {
              if (!Array.isArray(applications)) {
                return false;
              }

              return applications.some((application) => {
                const candidates = extractDiscountCandidates(application);
                return candidates.includes(normalizedDiscountCode);
              });
            };

            if (hasMatchingDiscount(cart.cart_level_discount_applications)) {
              return true;
            }

            if (hasMatchingDiscount(cart.discount_applications)) {
              return true;
            }

            if (hasMatchingDiscount(cart.discount_codes)) {
              return true;
            }

            if (hasMatchingDiscount(cart.discounts)) {
              return true;
            }

            if (Array.isArray(cart.items)) {
              const hasItemLevelMatch = cart.items.some((item) => {
                if (hasMatchingDiscount(item && item.discounts)) {
                  return true;
                }

                if (Array.isArray(item && item.line_level_discount_allocations)) {
                  return item.line_level_discount_allocations.some((allocation) => {
                    const discountApplication = allocation && allocation.discount_application;
                    const candidates = extractDiscountCandidates(discountApplication);
                    return candidates.includes(normalizedDiscountCode);
                  });
                }

                return false;
              });

              if (hasItemLevelMatch) {
                return true;
              }
            }

            return false;
          },

          async ensureSubscriptionCheckoutGift(cartData = null) {
            if (!ENABLE_SUBSCRIPTION_CHECKOUT_GIFT) {
              return false;
            }

            if (this.giftSyncInProgress) {
              return false;
            }

            try {
              const cart = cartData && Array.isArray(cartData.items) ? cartData : this.data;
              if (!cart || !Array.isArray(cart.items)) {
                return false;
              }

              const cartItems = cart && cart.items ? cart.items : [];
              const hasSubscription = this.hasSubscriptionItem(cartItems);
              const hasRequiredDiscount = this.hasActiveDiscountCode(cart, SUBSCRIPTION_CHECKOUT_GIFT_DISCOUNT_CODE);
              const existingGiftItem = this.findCartItemByVariant(cartItems, SUBSCRIPTION_CHECKOUT_GIFT_VARIANT_ID);
              const hasGiftAlready = !!existingGiftItem;

              if ((!hasSubscription || !hasRequiredDiscount) && existingGiftItem) {
                this.giftSyncInProgress = true;

                try {
                  const removeResponse = await fetch(window.Shopify.routes.root + 'cart/change.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      id: existingGiftItem.key,
                      quantity: 0,
                    }),
                  });

                  return removeResponse.ok;
                } finally {
                  this.giftSyncInProgress = false;
                }
              }

              if (!hasSubscription || !hasRequiredDiscount || hasGiftAlready) {
                return false;
              }

              const giftPayload = {
                items: [
                  {
                    id: SUBSCRIPTION_CHECKOUT_GIFT_VARIANT_ID,
                    quantity: 1,
                    properties: {
                      _title: 'Free Bottle',
                      _msrp: '0.00',
                      _savings: 100,
                      _price: '0.00',
                      _subscription_checkout_gift: true,
                    },
                  },
                ],
              };

              this.giftSyncInProgress = true;

              try {
                const addResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(giftPayload),
                });

                return addResponse.ok;
              } finally {
                this.giftSyncInProgress = false;
              }
            } catch (error) {
              console.error('Error ensuring subscription checkout gift:', error);
              this.giftSyncInProgress = false;
              return false;
            }
          },

          // Method to add or update an item in the cart
          async addOrUpdateItem(variantId, sellingPlanId, quantity, image, title, msrp, savings, price) {
            this.loading = true;

            try {
              // Ensure quantity is a number
              const numQuantity = parseInt(quantity);

              // Check if item already exists in cart
              const existingItem = this.findCartItem(variantId, sellingPlanId);

              if (existingItem) {
                // Update existing item with new quantity (replace, not add)
                await this.updateItem(existingItem.key, numQuantity);
              } else {
                // Add new item to cart
                await this.addItem(variantId, sellingPlanId, numQuantity, image, title, msrp, savings, price);
              }
            } catch (error) {
              console.error('Error adding or updating item in cart:', error);
            } finally {
              this.loading = false;
            }
          },

          // Method to add an item to the cart via the Shopify API
          async addItem(variantId, sellingPlanId, quantity, image, title, msrp, savings, price) {
            this.loading = true;
            let formData;

            if (sellingPlanId) {
              formData = {
                items: [
                  {
                    id: variantId,
                    quantity: quantity,
                    selling_plan: sellingPlanId,
                    properties: {
                      _image: image,
                      _title: title,
                      _msrp: msrp,
                      _savings: savings,
                      _price: price,
                      _selling_plan_id: sellingPlanId,
                    },
                  },
                ],
              };
            } else {
              formData = {
                items: [
                  {
                    id: variantId,
                    quantity: quantity,
                    properties: {
                      _image: image,
                      _title: title,
                      _msrp: msrp,
                      _savings: savings,
                      _price: price,
                    },
                  },
                ],
              };
            }

            try {
              const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
              });
              // After successful addition, refetch the global cart data to sync all components
              if (response.ok) {
                await this.getCartData();
                // Optional: Dispatch a custom window event for other components to react
                window.dispatchEvent(new CustomEvent('cart:updated'));

                var body = document.body;
                var sideCartScreen = document.getElementById('side-cart-screen');
                var sideCartContainer = document.getElementById('side-cart-wrapper');
                body.classList.toggle('overflow-hidden');
                sideCartScreen.classList.toggle('active');
                sideCartContainer.classList.toggle('open');
              }
            } catch (error) {
              console.error('Error adding item to cart:', error);
            } finally {
              this.loading = false;
            }
          },

          // Method to update an item in the cart via the Shopify API
          async updateItem(lineItemId, newQuantity) {
            this.loading = true;

            let formData = {
              id: lineItemId,
              quantity: newQuantity,
            };

            try {
              const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
              });
              // After successful change, refetch the global cart data to sync all components
              if (response.ok) {
                await this.getCartData();
                // Optional: Dispatch a custom window event for other components to react
                window.dispatchEvent(new CustomEvent('cart:updated'));

                var body = document.body;
                var sideCartScreen = document.getElementById('side-cart-screen');
                var sideCartContainer = document.getElementById('side-cart-wrapper');

                if (this.data.item_count === 0) {
                  // Close Cart if empty
                  body.classList.toggle('overflow-hidden');
                  sideCartScreen.classList.toggle('active');
                  sideCartContainer.classList.toggle('open');
                } else {
                  // Open Cart if items exist
                  if (!sideCartScreen.classList.contains('active')) {
                    body.classList.toggle('overflow-hidden');
                    sideCartScreen.classList.toggle('active');
                    sideCartContainer.classList.toggle('open');
                  }
                }
              }
            } catch (error) {
              console.error('Error adding item to cart:', error);
            } finally {
              this.loading = false;
            }
          },
        });

        fetch(window.Shopify.routes.root + 'cart.js')
          .then((response) => response.json())
          .then((cart) => {
            // console.log('Shopify Cart Data:', cart);
          })
          .catch((error) => {
            console.error('Error fetching cart:', error);
          });
      });

(function () {
  const CART_EXCLUDED_PRODUCT_IDS = [
    // Add lander product IDs here (product_id values from /cart.js), e.g. 1234567890
    9965210206451,
    9965211353331,
    9965210894579,
    9965169967347,
    9965171146995,
    9976508055795,
    9977848037619,
    9977103220979,
    9975565746419,
    9973731131635,
    9976082235635,
    9977395937523,
    9974939353331,
    9976842354931,
    9973911879923,
  ];

  let cartSanitizeInFlight = null;
  let cartSanitizeLastRunAt = 0;

  function normalizeExcludedProductIds() {
    return new Set(
      CART_EXCLUDED_PRODUCT_IDS.map((id) => parseInt(id, 10)).filter((id) => Number.isFinite(id) && id > 0)
    );
  }

  function isLanderMarkedItem(item) {
    if (!item || !item.properties) {
      return false;
    }

    const raw = item.properties._lander;
    return raw === true || raw === 'true' || raw === '1' || raw === 1;
  }

  function updateHeaderCartCount(count) {
    const safeCount = Number.isFinite(count) ? String(count) : '0';
    const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count, #cart-icon-bubble');

    cartCountElements.forEach((element) => {
      const target = element.querySelector('span') || element;
      target.textContent = safeCount;
    });
  }

  async function sanitizeExcludedCartItems(options = {}) {
    const { force = false } = options;

    if (cartSanitizeInFlight) {
      return cartSanitizeInFlight;
    }

    const now = Date.now();
    if (!force && now - cartSanitizeLastRunAt < 1200) {
      return false;
    }

    cartSanitizeInFlight = (async () => {
      try {
        const excludedProductIds = normalizeExcludedProductIds();

        const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
        if (!cartResponse.ok) {
          return false;
        }

        const cart = await cartResponse.json();
        if (!cart || !Array.isArray(cart.items) || !cart.items.length) {
          updateHeaderCartCount(0);
          return false;
        }

        const updates = {};

        cart.items.forEach((item) => {
          const productId = parseInt(item.product_id, 10);
          const inDenylist = Number.isFinite(productId) && excludedProductIds.has(productId);

          if (inDenylist || isLanderMarkedItem(item)) {
            updates[item.key] = 0;
          }
        });

        if (!Object.keys(updates).length) {
          updateHeaderCartCount(cart.item_count || 0);
          return false;
        }

        const updateResponse = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates }),
        });

        if (!updateResponse.ok) {
          return false;
        }

        const refreshedCart = await updateResponse.json();
        updateHeaderCartCount(refreshedCart && Number.isFinite(refreshedCart.item_count) ? refreshedCart.item_count : 0);

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        window.dispatchEvent(new CustomEvent('cart:updated'));

        try {
          if (window.Alpine && typeof window.Alpine.store === 'function') {
            const cartStore = window.Alpine.store('cart');
            if (cartStore && typeof cartStore.getCartData === 'function') {
              await cartStore.getCartData({ skipGiftSync: true });
            }
          }
        } catch (alpineError) {
          console.warn('Cart store refresh after sanitize failed:', alpineError);
        }

        return true;
      } catch (error) {
        console.error('Error sanitizing excluded cart items:', error);
        return false;
      } finally {
        cartSanitizeLastRunAt = Date.now();
        cartSanitizeInFlight = null;
      }
    })();

    return cartSanitizeInFlight;
  }

  function bindCartSanitizeTriggers() {
    document.addEventListener('click', (event) => {
      const trigger = event.target && event.target.closest
        ? event.target.closest('.side-cart-button, #cart-icon-bubble, [data-open-side-cart], [data-cart-open]')
        : null;

      if (trigger) {
        sanitizeExcludedCartItems();
      }
    }, true);

    window.addEventListener('pageshow', () => {
      sanitizeExcludedCartItems({ force: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      sanitizeExcludedCartItems({ force: true });
      bindCartSanitizeTriggers();
    });
  } else {
    sanitizeExcludedCartItems({ force: true });
    bindCartSanitizeTriggers();
  }

  function runWhenIdle(callback) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 4000 });
      return;
    }

    window.setTimeout(callback, 2500);
  }

  function initComet() {
    if (typeof window.comet === 'function') {
      window.comet('init');
    }
  }

  function loadComet() {
    if (window.__skinnyfitCometLoaded) return;
    window.__skinnyfitCometLoaded = true;

    const script = document.createElement('script');
    script.src = 'https://js.comet-serve.com/script.js?uid=9e836a-3377699734000017-a4f343-s';
    script.async = true;
    script.addEventListener('load', initComet, { once: true });
    document.body.appendChild(script);
  }

  function scheduleComet() {
    window.setTimeout(() => runWhenIdle(loadComet), 60000);
  }

  ['pointerdown', 'keydown', 'touchstart'].forEach((eventName) => {
    window.addEventListener(eventName, () => runWhenIdle(loadComet), { once: true, passive: true });
  });

  window.addEventListener('load', scheduleComet, { once: true });
})();

(function () {
        // Add or remove a class on every other .section-bg, starting with the second
        function stripeSectionBg() {
          const sections = Array.from(document.querySelectorAll('.section-bg'));
          if (!sections.length) return;
          sections.forEach((s) => s.classList.remove('section-bg--alt'));
          sections.forEach((s, i) => {
            if (i % 2 === 1) s.classList.add('section-bg--alt');
          });
        }

        // Simple debounce
        function debounce(fn, wait = 60) {
          let t;
          return function (...args) {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
          };
        }

        const run = debounce(stripeSectionBg, 80);

        document.addEventListener('DOMContentLoaded', run);
        window.addEventListener('load', run);

        // Shopify section events
        document.addEventListener('shopify:section:load', run);
        document.addEventListener('shopify:section:reorder', run);
        document.addEventListener('shopify:section:unload', run);

        // Fallback for dynamic DOM changes
        const observer = new MutationObserver(run);
        observer.observe(document.body, { childList: true, subtree: true });

        // Run immediately if appropriate
        if (document.readyState === 'interactive' || document.readyState === 'complete') run();
      })();

// Lander Buy Button
      (function () {
        class BtnBuy extends HTMLElement {
          constructor() {
            super();
            this.button = this.querySelector('.btn-buy');
          }

          connectedCallback() {
            this.button.addEventListener('click', this.handleClick.bind(this));
          }

          async handleClick(event) {
            event.preventDefault();

            const button = event.target;
            const variantId = button.dataset.variantId;
            const sellingPlanId = button.dataset.sellingPlanId;
            const image = button.dataset.image;
            const title = button.dataset.title;
            const msrp = button.dataset.msrp;
            const savings = button.dataset.savings;
            const price = button.dataset.price;

            if (!variantId) {
              console.error('No variant ID found');
              return;
            }

            button.disabled = true;
            const originalText = button.textContent;
            button.textContent = 'APPLYING DISCOUNT...';

            try {
              const response = await fetch('/cart/clear.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
              });

              if (response.ok) {
                if (window.location.pathname === '/cart') {
                  window.location.reload();
                } else {
                  document.dispatchEvent(new CustomEvent('cart:refresh'));

                  const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count, #cart-icon-bubble');
                  cartCountElements.forEach((element) => {
                    if (element.querySelector('span')) {
                      element.querySelector('span').textContent = '0';
                    } else {
                      element.textContent = '0';
                    }
                  });
                }
              } else {
                console.error('Failed to clear cart');
              }
            } catch (error) {
              console.error('Error clearing cart:', error);
            }

            try {
              let formData;
              if (sellingPlanId) {
                formData = {
                  items: [
                    {
                      id: '48520422850803',
                      quantity: 1,
                      properties: {
                        _image: 'product-lip-balm-free-gift.png',
                        _title: 'SkinnyFit Lip Balm',
                        _msrp: '28.00',
                        _savings: 100,
                        _price: 0,
                        _lander: true,
                      },
                    },
                    {
                      id: '48755545473267',
                      quantity: 1,
                      properties: {
                        _image: 'product-scrunchie-free-gift.png',
                        _title: 'SkinnyFit Silk Scrunchie',
                        _msrp: '22.00',
                        _savings: 100,
                        _price: 0,
                        _lander: true,
                      },
                    },
                    {
                      id: variantId,
                      quantity: 1,
                      selling_plan: sellingPlanId,
                      properties: {
                        _image: image,
                        _title: title,
                        _msrp: msrp,
                        _savings: savings,
                        _price: price,
                        _lander: true,
                      },
                    },
                  ],
                };
              } else {
                formData = {
                  items: [
                    {
                      id: variantId,
                      quantity: 1,
                      properties: {
                        _image: image,
                        _title: title,
                        _msrp: msrp,
                        _savings: savings,
                        _price: price,
                        _lander: true,
                      },
                    },
                  ],
                };
              }

              const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
              });

              if (!response.ok) {
                throw new Error('Failed to add to cart');
              }

              window.location.href = '/checkout';
              setTimeout(function () {
                button.disabled = false;
                button.textContent = originalText;
              }, 1000);
            } catch (error) {
              console.error('Error:', error);
              button.textContent = originalText;
              button.disabled = false;
              alert('There was an error processing your request. Please try again.');
            }
          }
        }

        customElements.define('btn-buy', BtnBuy);
      })();
